import { useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const SuperProfileFormButtons = ({ showUpdateConfirmationDialog }) => {
  const { isSubmitting, isValid, initialValues, values, handleSubmit } = useFormikContext();
  const history = useHistory();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const displayUpdateConfirmationDialog = initialValues.jobProfileId !== values.jobProfileId;

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
          {(text) => (
            <Button
              type="button"
              className="p-button-secondary"
              disabled={isSubmitting}
              label={text}
              onClick={() => {
                history.goBack();
              }}
            />
          )}
        </FormattedMessage>
        <FormattedMessage id="actions.save" defaultMessage="Save">
          {(text) => (
            <Button
              type="button"
              icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
              label={text}
              onClick={() => {
                if (displayUpdateConfirmationDialog) {
                  showUpdateConfirmationDialog();
                } else {
                  handleSubmit();
                }
              }}
              disabled={!isValid || isSubmitting || subscriptionIsExpired}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileFormButtons;
